import React from 'react';

const Hello: React.FC = () => {
  return (
    <div>
      <h1>Hello!</h1>
      <p>私のポートフォリオサイトへようこそ！</p>
      <p>このサイトでは私の紹介をしつつ、Webフロントの技術をいろいろ試したりしてます。</p>
      <p>サイバーパンクが好きなので、それっぽい感じで作ってます。</p>
    </div>
  );
};

export default Hello;